import React from 'react';


import { Navigation, Footer } from './Common/Navfot';

function Layout({ children }) {
  return (
    <div>
      <Navigation />
      <main className="pt-16">{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;



